
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentcolor","d":"M23.271 9.419A15.866 15.866 0 0019.9 5.51l2.8-2.8a1 1 0 00-1.414-1.414l-3.045 3.049A12.054 12.054 0 0012 2.655c-6.191 0-9.719 4.238-11.271 6.764a4.908 4.908 0 000 5.162A15.866 15.866 0 004.1 18.49l-2.8 2.8a1 1 0 101.414 1.414l3.052-3.052A12.054 12.054 0 0012 21.345c6.191 0 9.719-4.238 11.271-6.764a4.908 4.908 0 000-5.162zM2.433 13.534a2.918 2.918 0 010-3.068C3.767 8.3 6.782 4.655 12 4.655a10.1 10.1 0 014.766 1.165l-2.013 2.013a4.992 4.992 0 00-6.92 6.92l-2.31 2.31a13.723 13.723 0 01-3.09-3.529zM15 12a3 3 0 01-3 3 2.951 2.951 0 01-1.285-.3l3.985-3.985A2.951 2.951 0 0115 12zm-6 0a3 3 0 013-3 2.951 2.951 0 011.285.3L9.3 13.285A2.951 2.951 0 019 12zm12.567 1.534C20.233 15.7 17.218 19.345 12 19.345a10.1 10.1 0 01-4.766-1.165l2.013-2.013a4.992 4.992 0 006.92-6.92l2.31-2.31a13.723 13.723 0 013.09 3.529 2.918 2.918 0 010 3.068z"}})])
          )
        }
      }
    